import { Ban } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./ui/tooltip";

/**
 * Badge shown on games flagged as "Unplayable" in the MDB.
 * Uses a ban-icon pill with hover text explaining the game can no longer be
 * played but is kept for historical/statistical purposes.
 * Rendered on Browse tiles and the Browse game detail page.
 */
export function UnplayableBadge({ compact = false, className = "" }) {
  const label = compact ? "Unplayable" : "Currently Unplayable";
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            data-testid="unplayable-badge"
            className={
              "inline-flex items-center gap-1 rounded-full border border-rose-500/40 bg-rose-500/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-rose-300 " +
              className
            }
          >
            <Ban className="h-3 w-3" />
            {label}
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs text-xs leading-relaxed">
          This game is currently unplayable but is included in the database for
          historical and statistical purposes for those that played while it
          was active.
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default UnplayableBadge;
